import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { ChangeAddressRequest } from '../../../../models/users/requests/submissionRequests/change-address-request';
import { AbstractSubmissionFormViewModel } from '../submission-forms/abstract-submission-form/abstract-submission-form-view-model';

@Injectable()
export class AddressChangeSubmissionFormViewModel extends AbstractSubmissionFormViewModel<ChangeAddressRequest> {
  constructor(public router: Router, public ngbModal: NgbModal) {
    super(router, ngbModal);
  }

  protected createSubmissionMethod = (req: ChangeAddressRequest) =>
    this.submissionsDomainModel.createMemberAddressChangeSubmission(req);
  protected successMessage = $localize`Address Change Request Submitted`;
}
